import { gql } from "@apollo/client";

export const FRANCHISES = gql`
  query franchises {
    franchises {
      id
      name
      driver_quantity
      logo_path
      banner_path
      latitude
      longitude
      google_api_key
      whatsapp_phone
      whatsapp_phone_id
      whatsapp_token
      mercado_pago_access_token
      firebase_api_key
      firebase_auth_domain
      firebase_project_id
      firebase_storage_bucket
      firebase_sender_id
      firebase_app_id
      firebase_measurement_id
      firebase_database_url
      firebase_private_key_id
      firebase_private_key
      firebase_client_email
      firebase_client_id
      client_x509_cert_url
      is_actived
    }
  }
`;

export const FRANCHISE = gql`
  query franchise($id: Float!) {
    franchise(id: $id) {
      id
      name
      logo_path
      latitude
      longitude
      banner_path
      driver_quantity
      firebase_api_key
      firebase_auth_domain
      firebase_project_id
      firebase_storage_bucket
      firebase_sender_id
      firebase_app_id
      firebase_measurement_id
      firebase_database_url
    }
  }
`;

export default FRANCHISES;
